import { render } from "./PdfView.vue?vue&type=template&id=7ef65a5a&scoped=true"
import script from "./PdfView.vue?vue&type=script&lang=ts"
export * from "./PdfView.vue?vue&type=script&lang=ts"

import "./PdfView.vue?vue&type=style&index=0&id=7ef65a5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ef65a5a"

export default script